import './App.css';
import Portfolio from "../src/Portfolio";
function App() {
  return (
    <div className="App">
      <Portfolio />
    </div>
  );
}

export default App;
